import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

/** Liquid-glass surface. Works in light & dark via theme.applyStyles. */
export const GlassCard = styled(Box)(({ theme }) => ({
  background: 'rgba(255, 255, 255, 0.55)',
  backdropFilter: 'blur(18px) saturate(160%)',
  WebkitBackdropFilter: 'blur(18px) saturate(160%)',
  border: '1px solid rgba(255, 255, 255, 0.5)',
  borderRadius: (theme.shape.borderRadius as number) * 1.6,
  boxShadow: '0 12px 40px rgba(20, 24, 40, 0.12)',
  padding: theme.spacing(4),
  ...theme.applyStyles('dark', {
    background: 'rgba(18, 24, 38, 0.55)',
    border: '1px solid rgba(255, 255, 255, 0.10)',
    boxShadow: '0 16px 48px rgba(0, 0, 0, 0.5)',
  }),
}));
